import { render, staticRenderFns } from "./VeiculosGaragem.vue?vue&type=template&id=0e3d6642&scoped=true&"
import script from "./VeiculosGaragem.vue?vue&type=script&lang=js&"
export * from "./VeiculosGaragem.vue?vue&type=script&lang=js&"
import style0 from "./VeiculosGaragem.vue?vue&type=style&index=0&id=0e3d6642&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3d6642",
  null
  
)

export default component.exports